define('modules/start/collection',['require','exports','module','app','env','base/collection','./model'],function(require, exports, module) {
    "use strict";

    var app = require("app");
    var Config = require("env");
    var BaseCollection = require("base/collection");
    var ProductModel = require("./model");

    var Collection = BaseCollection.extend({
        model: ProductModel,
        url: function() {
            var url = Config.backendUrl + "/products";
            if (this.groupId !== undefined && this.groupId !== "0") {
                url = url + "/group/" + this.groupId;
            }
            return url;
        },
        initialize: function() {
            this.initRequestEvents();
        },
        parse: function(response, options) {
            var products = response._embedded.products;
            return products;
        },
        getMyCompanies: function() {
            var companies = [];
            _.each(this.models, function(model){
                if (model.get("activeServiceUser")) {
                    _.each(model.get("companies"), function(company) {

                        var found = _.find(companies, function(cmp) {
                            return cmp.id === company.id;
                        }, this);

                        if (company.activeServiceCompany && (found === undefined)) {
                            companies.push(company);
                        }

                    }, this);
                }
            }, this);

            return companies;
        },
        getCompanyName: function (myCompanies, companyId) {
            var name = '';
            _.each(myCompanies, function(company){
                if (parseInt(company.id) === parseInt(companyId)) {
                    name = company.name;
                }
            });
            return name;
        },
        setGroupId: function(groupId) {
            this.groupId = groupId;
        },
        groupHasService: function(service) {
            var found = _.find(this.models, function(currentService) {
                return (
                    (currentService.get("name") === service) &&
                    (currentService.get("companies").length > 0)
                );
            });

            return (found === undefined)? false : true;
        },
        getFirstCompanyFromService: function(service) {
            var product = _.find(this.models, function(currentProduct) {
                return (currentProduct.get("name") === service &&
                        currentProduct.get("companies").length > 0);
            });

            if (product) {
                return product.get("companies")[0];
            }

            product = _.find(this.models, function(currentProduct) {
                return (currentProduct.get("name") === service &&
                        currentProduct.get("deactivated_companies").length > 0);
            });

            if (product) {
                return product.get("deactivated_companies")[0];
            }
        }
    });

    module.exports = Collection;
});

